import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDeleteModal } from "../../../Settings/helpers/useDeleteModal";
import { useDeleteTimeSheet } from "../../api/useDeleteTimeSheet";
import { useActionWithAccess } from "../../../../utils/hooks/access";

export const useRemoveActions = ({ refetchOverview, setData, setTotalItems }) => {
    const { t } = useTranslation();

    const onRemoveSuccess = useCallback((ids) => {
        refetchOverview();
        setTotalItems((prev) => prev - ids.length);
        setData((prev) => prev?.filter(
            (prevTimeSheet) => !ids.includes(prevTimeSheet?.id)
        ));
    }, [refetchOverview, setTotalItems, setData]);

    const {
        remove: baseRemove,
        removeMany: baseRemoveMany,
    } = useDeleteTimeSheet();

    const removeOne = useActionWithAccess(
        useCallback((id) => {
            baseRemove(id, onRemoveSuccess.bind(null, [id]));
        }, [baseRemove, onRemoveSuccess]),
        "timeSheet.canDeleteMyTimesheet",
    );

    const removeMany = useActionWithAccess(
        useCallback((ids, dates, userId) => {
            baseRemoveMany(ids, dates, userId, onRemoveSuccess.bind(null, ids));
        }, [baseRemoveMany, onRemoveSuccess]),
        "timeSheet.canDeleteMyTimesheet",
    );

    const { modal, open } = useDeleteModal({
        message: (res) => {
            const { data } = res || {};
            const count = Array.isArray(data) ? data.length : 1;
            return t("do-you-want-to-delete-timesheets", { count });
        },
        permission: "timeSheet.canDeleteMyTimesheet",
        onConfirm: (res) => {
            const { data, dates, userId } = res || {};
            return Array.isArray(data)
                ? removeMany(data, dates, userId)
                : removeOne(data)
        },
    });

    const remove = useActionWithAccess(open, "timeSheet.canDeleteMyTimesheet");

    return { modal, remove };
}
